import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { api, apiError, downloadFile } from "@/lib/api";
import { gbp2 } from "./SaleExtras";

const monthName = (m) => new Date(`${m}-01T12:00:00`).toLocaleDateString("en-GB", { month: "long", year: "numeric" });
const TH = "p-3 font-semibold";

const SummaryRow = ({ r }) => (
  <tr className="border-b border-stone/60" data-testid={`sales-summary-${r.month}`}>
    <td className="p-3 font-semibold">{monthName(r.month)}</td>
    <td className="p-3" data-testid={`sales-summary-${r.month}-sales`}>{r.sales} · {gbp2(r.sales_total)}</td>
    <td className="p-3" data-testid={`sales-summary-${r.month}-extras`}>{r.extras_count} · {gbp2(r.extras_net)} + VAT {gbp2(r.extras_vat)}</td>
    <td className="p-3" data-testid={`sales-summary-${r.month}-vat`}><strong>{gbp2(r.vat_due)}</strong>{r.vehicle_vat ? <span className="block text-xs text-charcoal/75">incl. {gbp2(r.vehicle_vat)} on VAT-qualifying vehicles</span> : null}</td>
    <td className="p-3" data-testid={`sales-summary-${r.month}-lost`}>{r.lost ? `${r.lost} · ${gbp2(r.lost_total)}` : "None"}</td>
  </tr>
);

export function SalesSummary() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/admin/sales-summary").then((r) => setRows(Array.isArray(r.data) ? r.data : [])).catch(() => setRows([]));
  }, []);
  return (
    <section data-testid="sales-summary">
      <div className="mb-2 mt-12 flex flex-wrap items-center justify-between gap-3">
        <h2 className="font-serif text-2xl">Monthly sales</h2>
        <button type="button" disabled={!rows?.length} className="inline-flex items-center gap-2 border border-forest px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-forest hover:bg-forest hover:text-paper disabled:opacity-50"
          onClick={() => downloadFile("/admin/sales-summary/xlsx", `Cirencester-4x4-Monthly-Sales-${new Date().toISOString().slice(0, 10)}.xlsx`).catch((e) => toast.error(apiError(e)))}
          data-testid="sales-summary-download"><Download size={14} /> Download spreadsheet</button>
      </div>
      <p className="mb-4 text-sm text-charcoal/75">From your sale agreements. Sales count Agreed and Completed; lost sales are those marked Cancelled. VAT due is VAT on extras plus 20% VAT on invoices marked VAT qualifying.</p>
      <div className="overflow-x-auto border border-stone bg-paper">
        <table className="w-full min-w-[640px] text-left text-sm">
          <thead className="border-b border-stone text-xs uppercase tracking-[0.12em] text-charcoal/70">
            <tr><th className={TH}>Month</th><th className={TH}>Sales (total incl. extras)</th><th className={TH}>Extras sold</th><th className={TH}>VAT due</th><th className={TH}>Agreed then lost</th></tr>
          </thead>
          <tbody>
            {rows?.length === 0 && <tr><td className="p-4 text-charcoal/70" colSpan={5} data-testid="sales-summary-empty">No sales recorded yet.</td></tr>}
            {(rows || []).map((r) => <SummaryRow key={r.month} r={r} />)}
          </tbody>
        </table>
      </div>
    </section>
  );
}
